import { ATTACHEMENT_MAX_FILE_SIZE_MB } from "../shared/constants"

export const texts_cs = {
    brand: "ArbTask",
    brandDescription: 'Vytvořeno stromolezcem, pro práci se stromy.',

    loginPageHeadline: 'Vše, co potřebujete pro práci se stromy.',
    loginPageFeature1: 'Vaše zakázky na interaktivní mapě',
    loginPageFeature2: 'Profesionální generátor nabídek',
    loginPageFeature3: 'Databáze zákazníků',
    loginPageFeature4: 'Ukládejte fotografie z místa práce',
    loginPageFeature5: 'Pracovní výkazy pro váš tým',
    loginPageGetStarted: 'Chcete-li začít, zadejte svůj e-mail vpravo nebo se přihlaste přes Google nebo Facebook. Jste tu poprvé? Automaticky vytvoříme účet za vás.',
    loginPageMobileGetStarted: 'Chcete-li začít, zadejte svůj e-mail nebo se přihlaste přes Google nebo Facebook. Jste tu poprvé? Automaticky vytvoříme účet za vás.',
    loginPageGetStartedEmailOnly: 'Chcete-li začít, zadejte svůj e-mail vpravo. Jste tu poprvé? Automaticky vytvoříme účet za vás.',
    loginPageMobileGetStartedEmailOnly: 'Chcete-li začít, zadejte svůj e-mail. Jste tu poprvé? Automaticky vytvoříme účet za vás.',

    brand_cgh: "CGH",
    brandDescription_cgh: 'Zjednodušte své servisní operace.',

    defaultError: '💥 Něco se pokazilo. Prosím zkuste to znovu.',
    defaultSuccess: '🎉 Úspěch!',

    poweredByArbTask: 'Běží na ArbTask',
    delete: 'Smazat',
    edit: 'Upravit',
    cancel: 'Zrušit',
    save: 'Uložit',
    saving: 'Ukládání',
    saved: 'Uloženo',
    add: 'Přidat',
    view: 'Zobrazit',
    confirm: 'Potvrdit',
    create: 'Vytvořit',
    send: 'Odeslat',
    confirmation: 'Potvrzení',
    thisActionCannotBeUndone: 'Tato akce nemůže být vrácena.',
    attendees: 'Účastníci',
    name: 'Jméno',
    account: 'Účet',
    logout: 'Odhlásit se',
    archive: 'Archivovat',
    unarchive: 'Odarchivovat',
    archived: 'Archivováno',
    preview: 'Náhled',
    settings: 'Nastavení',
    userPreferences: 'Preference uživatele',
    orgSettings: 'Nastavení organizace',
    support: 'Podpora',
    supportDescription: 'Získejte pomoc s používáním ArbTask',
    contactSupport: 'Kontaktujte podporu',
    supportEmailDescription: 'Potřebujete pomoc? Máte otázku? Jsme tu, abychom vám pomohli vytěžit z ArbTask maximum.',
    emailUs: 'Napište nám na:',
    responseTime: 'Obvykle odpovídáme do 24 hodin během pracovních dnů.',
    frequentlyAskedQuestions: 'Často kladené otázky',
    stillNeedHelp: 'Stále potřebujete pomoc?',
    stillNeedHelpDescription: 'Pokud nemůžete najít to, co hledáte v našich často kladených otázkách, neváhejte se obrátit přímo na nás.',
    supportSendEmail: 'Pošlete nám e-mail',

    // Support FAQs
    faqCreateDealQ: 'Jak vytvořím novou zakázku?',
    faqCreateDealA: 'Pro vytvoření nové zakázky přejděte do zobrazení nástěnky a klikněte na tlačítko \'Nová zakázka\'. Vyplňte informace o zákazníkovi, polohu a všechny relevantní detaily o potřebné práci se stromy.',
    faqAddTeamMembersQ: 'Jak mohu přidat členy týmu do své organizace?',
    faqAddTeamMembersA: 'Přejděte do Nastavení organizace a klikněte na Správa týmu. Můžete pozvat nové členy zadáním jejich e-mailových adres. Obdrží pozvánku e-mailem pro připojení k vaší organizaci.',
    faqAttachFilesQ: 'Jak přiložím fotografie a dokumenty k zakázkám?',
    faqAttachFilesA: 'Při prohlížení zakázky se posuňte dolů do sekce příloh. Můžete přetáhnout soubory nebo kliknout pro procházení a výběr souborů. Ideální pro fotografie před/po, povolení nebo inspekční zprávy.',
    faqMapViewQ: 'Jak mohu zobrazit místa stromových služeb na mapě?',
    faqMapViewA: 'Použijte zobrazení Mapa z hlavní navigace k zobrazení všech vašich zakázek geograficky vynesených. To pomáhá s plánováním tras a pochopením pokrytí vaší servisní oblasti.',
    faqSendEstimatesQ: 'Jak posílám nabídky zákazníkům?',
    faqSendEstimatesA: 'Vytvořte nabídku v rámci zakázky, poté použijte funkci sdílení k vygenerování odkazu, který můžete poslat svému zákazníkovi. Mohou zobrazit a schválit nabídky bez potřeby účtu.',

    noData: 'Nic k zobrazení',
    contact: 'Kontakt',
    missing: 'Chybí',
    organizations: 'Organizace',
    close: 'Zavřít',
    thisFieldIsRequired: 'Toto pole je povinné',

    // RUT tax subsidy
    rutTaxSubsidy: 'RUT daňová sleva',
    rutDescription: 'Použít 50% daňovou slevu na domácí služby (RUT)',
    rutSubsidyAmount: 'Výše RUT slevy',
    toPay: 'K úhradě',

    // Login
    emailSentTo: 'E-mail odeslán na',
    checkSpamFolder: 'Pokud jej nevidíte, zkontrolujte složku spam.',
    newVersionAvailable: 'Je dostupná nová verze',
    reload: 'Obnovit',
    loginCodeInstructions: 'Klikněte na odkaz v e-mailu, nebo níže zadejte kód z něj.',
    loginCode: 'Přihlašovací kód',
    verifyLoginCode: 'Ověřit kód',
    invalidLoginCode: 'Neplatný nebo vypršelý kód',
    emailAddress: 'E-mailová adresa',
    enterEmail: 'Zadejte e-mail',
    login: 'Přihlásit se',
    acceptInvitation: 'Přijmout pozvání',
    signUp: 'Registrovat se',
    signInWithGoogle: 'Přihlásit se přes Google',
    signInWithFacebook: 'Přihlásit se přes Facebook',
    orDivider: 'nebo',

    // Deals
    pipeline: 'Nástěnka',
    newDeal: 'Nový obchod',
    mapView: 'Zobrazení mapy',
    map: 'Mapa',
    navigate: 'Navigovat',
    deals: 'Obchody',
    noDeals: 'Žádné obchody nenalezeny',
    deal: 'Obchod',
    editPipeline: 'Upravit nástěnku',
    editPipelineDescription: 'Spravujte kroky ve vašem prodejním procesu',
    orphanedDeals: 'Opuštěné obchody',
    orphanedDealsDescription: 'Obchody z odstraněných kroků prodejního procesu',
    addStep: 'Přidat krok',
    addStepDescription: 'Přidejte nový krok do vašeho prodejního procesu',
    newStep: 'Nový krok',
    removeStep: 'Odstranit krok',
    lastUpdated: 'Naposledy aktualizováno',
    description: 'Popis',
    address: 'Adresa',
    changeLayout: 'Změnit rozložení',
    changeLayoutDescription: 'Změnit rozložení karet viditelných na nástěnce',
    updatedAt: 'Naposledy aktualizováno',
    tags: 'Štítky',
    riskAssessment: 'Hodnocení rizik',
    riskLevel: 'Úroveň rizika',
    riskLow: 'Nízká',
    riskMedium: 'Střední',
    riskHigh: 'Vysoká',
    riskNotes: 'Poznámky (volitelné)',
    addRiskAssessment: 'Přidat hodnocení',
    enableRiskAssessment: 'Hodnocení rizik',
    noRiskAssessments: 'Žádná hodnocení nebyla zaznamenána',
    setCompanyAddressToEnableDistanceCalculation: 'Nastavte adresu společnosti pro povolení výpočtu vzdálenosti',

    // Actions
    actions: 'Akce',
    movedFromTo: 'Přesunuto z {from} do {to}',
    createdIn: 'Vytvořeno v {step}',
    day: 'den',
    days: 'dní',
    hour: 'hodina',
    hours: 'hodin',
    minute: 'minuta',
    minutes: 'minut',
    second: 'sekunda',
    seconds: 'sekund',
    beenHere: 'Zde {time}',
    hasNotBeenHere: 'Ještě zde nebyl',

    // Settings
    accountSettings: 'Nastavení účtu',
    accountSettingsDescription: 'Spravujte nastavení svého účtu',
    language: 'Jazyk',
    languageDescription: 'Vyberte jazyk pro aplikaci',
    logo: 'Logo',
    changeLogo: 'Změnit logo',
    uploadLogo: 'Nahrát logo',

    // Organization Settings
    organizationSettings: 'Nastavení organizace',
    organizationSettingsDescription: 'Spravujte nastavení vaší organizace',
    headquarterDescription: 'Nastavte adresu vaší společnosti',
    organizationNameDescription: 'Nastavte viditelný název vaší společnosti',
    organizationEmailDescription: 'E-mail společnosti se používá pro oznámení',
    organizationLogoDescription: 'Nahrajte logo vaší společnosti',
    organizationWebsiteDescription: 'Webová stránka společnosti se používá k zobrazení informací o vaší organizaci',
    organizationNameRequired: 'Název organizace je povinný. Nastavte jej a uložte formulář.',
    currency: 'Měna',
    currencyDescription: 'Měna používaná v nabídkách a cenách',
    paymentInstructions: 'Platební instrukce',
    paymentInstructionsDescription: 'Zobrazuje se na fakturách, aby zákazníci věděli, jak zaplatit (např. bankovní účet, Swish nebo variabilní symbol).',

    // Organization Tabs & Features
    details: 'Detaily',
    features: 'Funkce',
    enableHoursTracking: 'Povolit sledování hodin',

    // Danger Zone
    dangerZone: 'Nebezpečná zóna',
    createNewOrganization: 'Vytvořit novou organizaci',
    createNewOrganizationDescription: 'Vytvořte samostatnou novou organizaci. Ihned do ní přepnete.',
    organizationCreated: 'Organizace byla vytvořena',
    deleteOrganization: 'Smazat organizaci',
    deleteOrganizationDescription: 'Trvale smazat tuto organizaci, včetně všech obchodů, zákazníků, položek, vybavení a záznamů času. Tuto akci nelze vrátit zpět.',
    deleteOrganizationWarning: 'Tímto trvale smažete tuto organizaci a všechny její obchody, zákazníky, položky, vybavení a záznamy času.',
    deleteOrganizationOwnerOnly: 'Pouze vlastník organizace může organizaci smazat.',
    organizationDeleted: 'Organizace byla smazána',
    typeNameToConfirm: 'Pro potvrzení napište název níže:',
    transferOwnership: 'Převést vlastnictví',
    transferOwnershipDescription: 'Nastavte jiného člena týmu jako vlastníka této organizace. Vy se stanete členem.',
    transferOwnershipOwnerOnly: 'Pouze vlastník organizace může převést vlastnictví.',
    transferOwnershipModalTitle: 'Převést vlastnictví',
    transferOwnershipSelectMember: 'Vyberte člena, který se stane novým vlastníkem',
    transferOwnershipNoEligibleMembers: 'Před převodem vlastnictví pozvěte člena týmu.',
    transferOwnershipWarning: 'Chystáte se učinit {email} vlastníkem této organizace. Stanete se členem a ztratíte přístup vyhrazený pouze vlastníkovi, například k fakturaci a mazání organizace.',
    transferOwnershipConfirmEmail: 'Pro potvrzení napište e-mail nového vlastníka níže:',
    ownershipTransferred: 'Vlastnictví bylo převedeno',

    // Articles
    articles: 'Artikly',
    article: 'Artikl',
    newArticle: 'Nový artikl',
    editArticle: 'Upravit artikl',
    price: 'Cena',
    vat: 'DPH',
    searchArticle: 'Hledat artikl',
    createNewArticle: 'Vytvořit nový artikl',
    priceWithVat: 'Cena s DPH',
    priceWithoutVat: 'Cena bez DPH',
    priceWithoutVatPerHour: 'Cena za hodinu bez DPH',
    articlesDescription: 'Artikly jsou položky nebo služby, které lze přidat do nabídek a faktur.',
    distanceBasedArticle: 'Artikl založený na vzdálenosti',
    distanceBasedDescription: 'Pro cestovní náklady. Tento artikl bude automaticky přidán do nabídek s množstvím odpovídajícím vzdálenosti v kilometrech.',
    isActivityArticle: 'Zaznamenatelná aktivita',
    isActivityArticleDescription: 'Tento artikl představuje aktivitu, kterou lze zaznamenávat do výkazů práce, oceněnou za hodinu.',

    // Equipment
    equipment: 'Vybavení',
    equipmentDescription: 'Sledujte nářadí a vybavení ve vlastnictví vaší organizace.',
    newEquipment: 'Nové vybavení',
    editEquipment: 'Upravit vybavení',
    equipmentCategory: 'Kategorie',
    equipmentMake: 'Značka',
    equipmentModel: 'Model',
    equipmentSerialNumber: 'Sériové číslo',
    equipmentPurchaseDate: 'Datum nákupu',
    equipmentPurchasePrice: 'Nákupní cena',
    equipmentCurrentValue: 'Aktuální hodnota',
    equipmentNotes: 'Poznámky',
    equipmentTotalPurchaseValue: 'Celková nákupní hodnota',
    equipmentTotalCurrentValue: 'Celková aktuální hodnota',
    equipmentCategoryChainsaw: 'Motorová pila',
    equipmentCategoryClimbingGear: 'Horolezecké vybavení',
    equipmentCategoryTruck: 'Nákladní auto',
    equipmentCategoryChipper: 'Štěpkovač',
    equipmentCategoryRigging: 'Vázací prostředky',
    equipmentCategoryHandTools: 'Ruční nářadí',
    equipmentCategoryOther: 'Ostatní',

    // TimeSheets
    timesheets: 'Časové výkazy',
    tuesday: 'Út',
    wednesday: 'St',
    thursday: 'Čt',
    friday: 'Pá',
    saturday: 'So',
    perDay: 'Po dnech',
    perWeek: 'Po týdnech',
    week: 'Týden',
    weekShort: 't',
    totalHours: 'Celkem hodin',
    newTimesheetEntry: 'Nový časový výkaz',
    trackedTime: 'Odpracovaný čas',
    addTime: 'Přidat čas',
    startWorking: 'Začít práci',
    stopWorking: 'Ukončit práci',
    workingSince: 'Pracuje od',
    start: 'Začátek',
    end: 'Konec',
    totalTimeHoursMinutes: 'Celkový čas (hodiny : minuty)',
    notes: 'Poznámky',
    viewTimeline: 'Zobrazit časovou osu',
    required: 'Povinné',
    seeDealTimeLine: 'Zobrazit časovou osu obchodu',
    timeline: 'Časová osa obchodu',
    timeRecords: 'Záznamy času',
    endDateAfterStartDate: 'Datum ukončení by mělo být po datu zahájení',
    hoursTracked: 'Sledované hodiny',
    deleteTimeRecord: 'Opravdu chcete smazat tento záznam času?',
    dealDetails: 'Detaily obchodu',
    exportCsv: 'Exportovat CSV',

    // Invoices
    invoices: 'Faktury',
    invoice: 'Faktura',
    createInvoice: 'Vytvořit fakturu',
    partialInvoice: 'Částečná faktura',
    invoiceCreated: 'Faktura vytvořena',
    invoiceStatusDraft: 'Koncept',
    invoiceStatusSent: 'Odesláno',
    invoiceStatusPaid: 'Zaplaceno',
    invoiceStatusCancelled: 'Zrušeno',
    period: 'Období',
    sendInvoice: 'Odeslat fakturu',
    sendInvoiceDescription: 'Odešlete zákazníkovi fakturu jako odkaz pouze pro čtení.',
    shareInvoiceMailto: "Dobrý den, {customerName},\n\nFakturu si můžete prohlédnout zde:\n{link}\n\nS pozdravem,\n{organizationName}",
    shareInvoiceMailtoSubject: "Nová faktura od {organizationName}",
    shareInvoiceSms: "Dobrý den, {customerName}, fakturu od {organizationName} si můžete prohlédnout zde: {link}",

    // Activities
    activity: 'Aktivita',
    splitHoursByActivity: 'Rozdělit hodiny podle aktivity',
    fillRemaining: 'Doplnit zbytek',
    assignedHours: 'Přiřazeno',
    remainingHours: 'Zbývá',
    activitySplitMismatch: 'Hodiny přiřazené aktivitám musí odpovídat celkovému času.',
    groupBy: 'Seskupit podle',
    unassignedActivity: 'Bez aktivity',

    // Search
    search: 'Hledat',
    noResults: 'Žádné výsledky nenalezeny',

    // Offers
    offer: 'Nabídka',
    offers: 'Nabídky',
    offersDescription: 'Spravujte své nabídky',
    comingSoon: 'Připravujeme',
    editDeal: 'Upravit obchod',
    newOffer: 'Nová nabídka',
    offerCreated: 'Nabídka úspěšně vytvořena',
    acceptedOffer: 'Přijatá nabídka',
    offerOpenedByCustomer: 'Nabídka otevřena zákazníkem',
    offerAccepted: 'Nabídka přijata zákazníkem',
    customerLeftComment: 'Zákazník zanechal komentář',
    acceptOffer: 'Přijmout nabídku',
    comment: 'Komentář',
    latestOffer: 'Poslední nabídka',
    manageOffers: 'Spravovat nabídky',
    pending: 'Čeká na schválení',
    saveAsTemplate: 'Uložit jako šablonu',
    noLocationSet: 'Žádné umístění nenastaveno',
    useCurrentLocation: 'Použít aktuální polohu',
    gettingLocation: 'Získávání polohy...',
    pickOnMap: 'Vybrat na mapě',
    useThisLocation: 'Použít tuto polohu?',
    locationPermissionDenied: 'Oprávnění k poloze bylo zamítnuto',
    locationNotSupported: 'Poloha není podporována vaším prohlížečem',
    locationError: 'Nepodařilo se získat vaši polohu',
    noOffer: 'Žádná nabídka',

    // Attachements
    attachments: 'Přílohy',
    addAttachment: 'Přidat přílohu',
    fileSizeTooLarge: `Soubor je příliš velký ({size} MB). Maximum povoleno ${ATTACHEMENT_MAX_FILE_SIZE_MB} MB.`,
    deleteAttachement: 'Smazat přílohu',
    dropFileHere: 'Přetáhněte soubor sem',
    takePhoto: 'Vyfotit',
    noAttachments: 'Žádné přílohy k dispozici',
    photos: 'Fotografie',
    dragImagesHere: 'Přetáhněte obrázky sem nebo klikněte pro výběr',
    browseFiles: 'Vybrat soubory',
    download: 'Stáhnout',

    // Customers
    customer: 'Zákazník',
    customers: 'Zákazníci',
    person: 'Osoba',
    company: 'Společnost',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    phone: 'Telefon',
    email: 'E-mail',
    website: 'Webová stránka',
    personalNumber: 'Rodné číslo',
    personalNumberShort: 'RČ', // Rodné číslo zkratka
    organizationNumber: 'IČO',
    newCustomer: 'Nový zákazník',
    editCustomer: 'Upravit zákazníka',
    note: 'Poznámka',
    searchCustomer: 'Hledat zákazníka',
    pressEnterToCreateNewCustomer: 'Stiskněte enter pro vytvoření <b>nového zákazníka</b>',
    changeCustomer: 'Změnit zákazníka',

    // Filters
    filters: 'Filtry',
    clear: 'Vyčistit',
    step: 'Krok',

    // Due Date
    dueDate: 'Termín',
    addDueDate: 'Přidat termín',

    // Team
    team: 'Tým',
    teamDescription: 'Spravujte členy týmu vaší organizace',
    addMember: 'Přidat člena',
    inviteMember: 'Pozvat člena týmu',
    enterEmails: 'Zadejte e-maily oddělené čárkami',
    invalidEmails: 'Zadejte platné e-mailové adresy.',
    role: 'Role',
    status: 'Stav',
    invitationsCreated: 'Pozvánky pro členy vytvořeny',
    manager: 'Manažer',
    worker: 'Pracovník',
    memberDescription: 'Může vidět všechny práce a spravovat je',
    workerDescription: 'Může vidět pouze práce, které mu byly přiřazeny',
    admin: 'Admin',
    sendingInvitation: 'Odesílání pozvánky',
    invitationSent: 'Pozvánka odeslána',
    accepted: 'Přijato',
    viewed: 'Zobrazeno',
    copyInvitationLink: 'Kopírovat odkaz pozvánky',
    invitationLinkCopied: 'Odkaz pozvánky zkopírován do schránky',
    changeRole: 'Změnit roli',
    changeRoleModalTitle: 'Změnit roli člena',
    changeRoleDelayWarning: 'Může trvat až hodinu, než se nová role projeví, nebo dokud se člen znovu nepřihlásí.',
    roleUpdated: 'Role byla aktualizována',
    paused: 'Neaktivní',
    pauseMember: 'Deaktivovat člena',
    reactivateMember: 'Aktivovat člena',
    memberPaused: 'Člen deaktivován',
    memberReactivated: 'Člen aktivován',

    // Share
    share: 'Sdílet',
    shareDeal: 'Sdílet obchod',
    shareDescription: 'Sdílet obchod s externím uživatelem',
    linkCoppied: 'Odkaz zkopírován do schránky',
    readonly: 'Pouze pro čtení',

    // Not found
    notFound: '404 - Nenalezeno',
    notFoundDescription: 'Toto nejsou stromy, které hledáte.',

    // Background Color
    backgroundColor: "Barva pozadí",
    chooseColor: "Vyberte barvu",

    // Block Types
    textBlock: "Text",
    imageBlock: "Obrázek",
    headingBlock: "Nadpis",
    lineBlock: "Čára",
    organizationCustomerBlock: "Organizace & Zákazník",

    // Organization/Customer Block
    organization: "Organizace",
    seller: "Prodejce",
    editOrganization: "Upravit organizaci",
    noCustomer: "Není vybrán žádný zákazník",
    noName: "Bezejmenný",
    addRow: "Přidat řádek",

    // Line items table
    quantity: "Množství",
    total: "Celkem",
    moveUp: "Posunout nahoru",
    moveDown: "Posunout dolů",
    deleteRow: "Smazat řádek",
    excludingVat: "Bez DPH",
    addDiscount: 'Přidat slevu',
    discount: 'Sleva',

    sendOffer: "Odeslat nabídku",
    sendOfferDescription: "Odeslat nabídku zákazníkovi. Budete informováni, když zákazník nabídku otevře.",
    shareOfferMailto: "Vážený/á {customerName},\n\nNabídku můžete zobrazit zde:\n{link}\n\nS pozdravem,\n{organizationName}",
    shareOfferMailtoSubject: "Nová nabídka od {organizationName}",
    shareOfferSms: "Dobrý den, {customerName}, nabídku od {organizationName} si můžete prohlédnout zde: {link}",
    sendEmail: "Odeslat e-mail",
    sendSMS: "Odeslat SMS",

    // Tree service texts
    treeServiceDescription: "Jsme hrdí na poskytování vysoce kvalitních služeb v péči o stromy, které jsou přizpůsobeny vašim potřebám. S naším zkušeným týmem a profesionálním přístupem zajišťujeme, že vaše stromy zůstanou zdravé, bezpečné a krásné po celý rok. Chápeme důležitost pečlivého plánování a precizního provedení každého projektu.",
    treeServiceThankYou: "Děkujeme, že zvažujete naše služby pro péči o vaše stromy.",

    // Integrations
    integrations: 'Integrace',
    integrationsDescription: 'Propojte vaši organizaci s externími službami pro rozšíření funkčnosti',
    customerForm: 'Zákaznický formulář',
    customerFormDescription: 'Použijte tento formulář, aby zákazníci mohli vytvářet obchody přímo ve vaší organizaci a vyhnout se tak ručnímu zadávání dat.',
    customerFormHint: 'Použijte odkaz pro nahrazení kontaktních formulářů na vašem webu nebo sociálních médiích.',
    customerFormLanguage: 'Jazyk formuláře',
    customerFormLanguageDescription: 'Jazyk, který zákazníci uvidí při otevření tohoto formuláře.',
    customerFormIntroLabel: 'Úvodní nadpis',
    customerFormIntroDescription: 'Zobrazuje se v horní části formuláře. Ponechte prázdné pro použití výchozího textu.',
    customerFormThankYouLabel: 'Poděkování',
    customerFormThankYouDescription: 'Zobrazuje se zákazníkům po odeslání formuláře. Ponechte prázdné pro použití výchozího textu.',
    accounting: 'Účetnictví',
    fortnoxConnected: 'Fortnox je připojen.',
    fortnoxDescription: 'Propojte svůj účet Fortnox pro synchronizaci zákazníků a článků.',
    connectFortnox: 'Připojit Fortnox',
    failedToConnectFortnox: 'Nepodařilo se připojit Fortnox',
    failedToInitiateFortnoxConnection: 'Nepodařilo se zahájit připojení k Fortnox',
    syncCustomers: 'Synchronizovat zákazníky',
    failedToSyncCustomers: 'Nepodařilo se synchronizovat zákazníky',
    syncCustomersResult: 'Synchronizace dokončena: {imported} importováno, {linked} propojeno, {pushed} odesláno do Fortnoxu.',
    tellUseAboutYourProject: "Řekněte nám o vašem projektu",

    // Members
    members: 'Členové',
    allMembers: 'Všichni členové',
    noMembersAssigned: 'Nejsou přiřazeni žádní členové',

    // Comments
    comments: 'Komentáře',
    noComments: 'Zatím žádné komentáře',
    writeComment: 'Napište komentář...',
    addComment: 'Přidat komentář',

    // Avatar
    changeAvatar: 'Změnit avatar',
    avatarLinkedToGravatar: 'Tento avatar je propojen s {email} přes Gravatar.',
    avatarUpdateTime: 'Může trvat několik minut, než se nový avatar zobrazí zde po jeho změně na Gravataru.',

    // Billing page copy
    billing: 'Fakturace',
    billingDescription: 'Spravujte své předplatné a podívejte se na dostupné plány.',
    plan: 'Plán',
    currentPlan: 'Aktuální plán',
    availablePlans: 'Vyberte plán, který odpovídá vašemu pracovnímu vytížení',
    dealsPerMonth: 'Zakázky za měsíc',
    upgrade: 'Upgradovat',
    free: 'Zdarma',
    base: 'Základní',
    selectPlan: 'Vybrat plán',
    current: 'Aktuální',
    billingHeading: 'Jednoduché, férové ceny, které rostou s vaší prací',
    billingIntro1: 'Plaťte pouze za zakázky, které aktivně řídíte - ne za počet uživatelů v týmu.',
    billingIntro2: 'Pozvěte celý tým, spravujte neomezený počet klientů a škálujte svůj plán podle pracovní zátěže.',
    billingFeature1: 'Neomezený počet členů týmu',
    billingFeature2: 'Plaťte pouze za aktivní zakázky',
    billingFeature3: 'Upgrade nebo downgrade kdykoli',
    billingWhyTitle: 'Proč ceník ArbTask funguje pro arboristické firmy',
    billingWhyPara1: 'Práce na stromech je sezónní. Některé měsíce jsou plné, jiné klidnější.',
    billingWhyPara2: 'Ceník ArbTask je navržen tak, abyste platili pouze za práci, kterou skutečně řídíte.',
    billingWhyBullet1: 'Férovost pro sezónní firmy - ceny se přizpůsobují vaší pracovní zátěži',
    billingWhyBullet2: 'Neomezený počet členů týmu - přidejte celý tým bez extra poplatků',
    billingWhyBullet3: 'Archivujte dokončené zakázky kdykoli - okamžitě uvolněte místo',
    billingWhyBullet4: 'Snadné škálování nahoru i dolů - změňte plán kdykoli',
    billingFooter1: 'Dokončené zakázky můžete kdykoli archivovat a uvolnit tak aktivní sloty.',
    billingFooter2: 'Žádné smlouvy. Žádné poplatky za uživatele.',
    trialActive: 'Zkušební období aktivní',
    trialActiveUntil: 'neomezený počet zakázek do',
    unlimited: 'Neom.',
    activeDeals: 'aktivní zakázky',
    billedMonthly: 'Účtováno měsíčně',
    billedAnnually: 'Účtováno ročně',
    perMonth: '/měs.',
    perYear: '/rok',
    dealLimitReached: 'Dosáhli jste limitu aktivních zakázek pro váš aktuální plán. Archivujte dokončené zakázky nebo upgradujte svůj plán pro přidání dalších aktivních zakázek.',
    dealLimitReachedNative: 'Dosáhli jste limitu aktivních zakázek pro váš aktuální plán. Archivujte dokončené zakázky pro přidání dalších aktivních zakázek.',
    usageSectionHeader: 'Vaše aktuální využití',
    usageSectionDescription: 'Toto ukazuje, kolik aktivních zakázek aktuálně používáte z limitu vašeho plánu. Archivujte dokončené zakázky pro uvolnění slotů.',

    // Plan cards
    planTagLine0: 'Nejlepší pro malé týmy, které teprve začínají',
    planTagLine1: 'Nejlepší pro malé rostoucí týmy',
    planTagLine2: 'Nejlepší pro zavedené arboristické firmy',
    planTagLine3: 'Nejlepší pro velké provozy',
    planTagLineUnder0: 'Nejlepší pro malé týmy, které teprve začínají',
    planTagLineUnder1: 'Spravujte mnoho projektů bez dosažení limitů.',
    planTagLineUnder2: 'Navrženo pro firmy spravující mnoho týmů a aktivních projektů.',
    planTagLineUnder3: 'Provozujte celou svou operaci bez omezení.',
    planBenefit00: 'Neomezený počet uživatelů',
    planBenefit01: 'Správa klientů',
    planBenefit10: 'Vše ze Zdarma',
    planBenefit11: 'Spravujte až 30 aktivních zakázek',
    planBenefit20: 'Vše ze Starteru',
    planBenefit21: 'Spravujte až 100 aktivních zakázek',
    planBenefit30: 'Vše z Growth',
    planBenefit31: 'Neomezený počet aktivních zakázek',
}
